import templates from "../templates";

import jQuery from "jquery";
import { EVENT } from "../data/constants";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { LocationProvider } from "../stores-js/location/locationprovider";
import { OriginDestinationInput } from "../stores-js/ui/origindestinationinput";
import { EventManager, createAutocompleteInput } from "../utils/global";
import { hideGeolocationNotice, showGeolocationNotice } from "../utils/notice";
import { FilterSystem, FiltersManager, initBlockButtons, initDragScroll } from "../utils/ui";

const $ = jQuery;

export default class SearchView {
    // eslint-disable-next-line no-unused-vars
    constructor(sidePanel, autocompleteByName, business) {
        const self = this;

        this.selector = ".wm-search";
        this.sidePanel = sidePanel;
        this.mapView = sidePanel.mapView;
        this.autocompleteByName = autocompleteByName;

        this.location = null;

        this.resultStoreSearchById = null;

        // if itinerary{
        SERVICE_REGISTRY.itinaryService.init(this.mapView);
        // }

        this.mainElement = $(this.selector);
        this.mainElement.html(
            templates.desktop.search.render({
                ui: total.maps.L10n.ui,
                itinerary: SETTINGS.itinerary,
                displaySearch: SETTINGS.displaySearch ? "" : "none",
            }),
        );
        // Set filters containers html
        // this.mainElement.find("#storemap-filters-list-container").append(SERVICE_REGISTRY.filterService.getTemplate());
        SERVICE_REGISTRY.filterService._triggerClickOnDefaultActiveFilters();
        window.reinitIcons();
        initBlockButtons();

        const datetimeContainer = this.mainElement.find(
            "#storemap-alongtheroadfilters-container .storemap-inputbar-container",
        );
        function onItinaryDateChange(selectedDate) {
            const currentDate = new Date();

            if (currentDate > selectedDate) {
                const departureTime = Math.floor(currentDate.getTime() / 1000);
                SERVICE_REGISTRY.itinaryService.setStartDatetime(departureTime);
            } else {
                const departureTime = selectedDate.getTime() / 1000;
                SERVICE_REGISTRY.itinaryService.setStartDatetime(departureTime);
            }
        }
        const $departureTimeElement = this.mainElement.find(".storemap-alongtheroad-departure-datetime-input")[0];
        if ($departureTimeElement) {
            datetimeContainer.addClass("storemap-inputbar-container-inactive");
            $departureTimeElement.addEventListener("change", () => {
                if ($departureTimeElement.value !== "") {
                    datetimeContainer.removeClass("storemap-inputbar-container-inactive");
                    const newDate = new Date($departureTimeElement.value);
                    onItinaryDateChange(newDate);
                }
                $departureTimeElement.blur();
            });
            if ($departureTimeElement.value === "") {
                datetimeContainer.addClass("storemap-inputbar-container-inactive");
            }
        }

        /*
         *    Woosmap element
         */

        // SearchView top

        const topOnLocationChangeCallback = function () {
            const details = this.get("details");
            if (details.store) {
                self.mainElement.find(".wm-autocomplete").hide();
                self.mainElement.find(".wm-search--input").val(details.location.description);
                self.sidePanel.setStoreSelectedFromMap(true);
                SERVICE_REGISTRY.storeService.setSelectedStore(details.store, false);
                self.mapView.zoomToStore(details.store);
            } else {
                self.mapView.setSearchBounds(details.viewpoint.bounds);
                const { location } = details;
                const locationText = self.mainElement.find(".wm-search--input").val();
                const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;
                SERVICE_REGISTRY.itinaryService.setOrigin(location);
                SERVICE_REGISTRY.locationService.setLocation(location, locationText, blockSearchNearbyStores);
            }
        };

        // Always use the new responsive search input. The legacy searchInputTopAviation.htm
        // uses the old storemap-* markup; aviation keeps this design and the generic search hint.
        const template = templates.desktop.searchInputTop;

        createAutocompleteInput(
            this.mainElement,
            this.mapView.initialBounds,
            template,
            "wm-search--container",
            "wm-autocomplete",
            topOnLocationChangeCallback,
            autocompleteByName,
        );

        // SearchView bottom

        const bottomOnLocationChangeCallback = function () {
            SERVICE_REGISTRY.itinaryService.setDestination(this.get("location"));
        };

        // OriginSedtination and DirectionsRenderer

        this.woosmapOriginDestinationInput = new OriginDestinationInput(templates.desktop.directions.render(), {
            geolocText: total.maps.L10n.ui.common.myLocation,
        });

        // Geolocation
        this.woosmapNavigatorGeolocation = new LocationProvider();

        this.woosmapNavigatorGeolocation.location_changed = function () {
            if (this.get("location").source === "html5") {
                const location = this.get("location");
                const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;

                SERVICE_REGISTRY.locationService.setLocation(
                    location,
                    total.maps.L10n.ui.common.myLocation,
                    blockSearchNearbyStores,
                    "gps",
                );
                self.mapView.setSearchBounds(null);

                SERVICE_REGISTRY.itinaryService.setOrigin(location);

                const inputElement = self.mainElement.find("#wm-search--container .wm-search--input");
                if (inputElement.val() === "") {
                    inputElement.val(total.maps.L10n.ui.common.myLocation);
                }
                inputElement.blur();
                // self.mainElement.find(".storemap-inputbar-clear-button").show();
            }
        };

        this._wireEvents();
    }

    show() {
        this.mainElement.show();
    }

    hide() {
        this.mainElement.hide();
    }

    // Hide the predictions overlay (dropdown + store-by-id result) only. Deliberately leaves
    // stores/location untouched — see clearSearchInput for the resetting variant.
    _hidePredictionsOverlay() {
        this.mainElement.find(".wm-autocomplete").hide();

        const resultStoreByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
        resultStoreByIdContainer.hide();
        resultStoreByIdContainer.find(".storemap-suggestion-item").text("");
    }

    dismissPredictions() {
        this._hidePredictionsOverlay();
        this.resultStoreSearchById = null;
    }

    _wireEvents() {
        const self = this;

        const itinaryStartDatetimeClearButton = $(
            "#storemap-input-itinary-start-datetime-container .storemap-inputbar-clear-button",
        );
        const itinaryStartDatetineInput = $(
            "#storemap-input-itinary-start-datetime-container .storemap-inputbar-input",
        );
        const openFilterModal = $('[data-id="filters-button-desktop"], [data-id="filters-button-mobile"]');
        if (openFilterModal) {
            openFilterModal.on("click", () => {
                FiltersManager.openModal();
            });
        }
        const favorites = SERVICE_REGISTRY.filterService.renderFavorites();
        if (favorites) {
            const favoritesContainer = document.querySelector(".wm-filters-fav");
            for (const element of favorites) {
                favoritesContainer.append(element);
            }
            FilterSystem.updateButtons();
            initDragScroll(favoritesContainer);
        }

        // business rule : close filter containers when click on search bar
        function onSearchBarClick() {
            SERVICE_REGISTRY.filterService.closeContainers();
        }

        function onTopClearButtonClick() {
            self.clearSearchInput();
            SERVICE_REGISTRY.locationService.resetLocation();
            SERVICE_REGISTRY.itinaryService.setOrigin(null);
        }

        function onBottomClearButtonClick() {
            self.clearSearchInput();
            SERVICE_REGISTRY.itinaryService.setDestination(null);
        }

        function onItinaryStartDatetimeClearButtonClick() {
            itinaryStartDatetineInput.val("");
            itinaryStartDatetimeClearButton.hide();
            SERVICE_REGISTRY.itinaryService.setStartDatetime(null);
        }
        function focusInputBox() {
            self.mainElement.find("#wm-search--container .wm-search--input").focus();
        }

        function onItinaryStartDatetimeInputChange() {
            itinaryStartDatetimeClearButton.toggle(itinaryStartDatetineInput.val() !== "");
        }

        function onGeolocalisationButtonClick() {
            hideGeolocationNotice();
            self.woosmapNavigatorGeolocation.askForLocation(navigator.geolocation, (error) => {
                if (error && error.code === error.PERMISSION_DENIED) {
                    showGeolocationNotice();
                }
            });
            self.mainElement.find(".wm-autocomplete").hide();
            EventManager.notify(EVENT.GEOLOCATION_CLICKED, null);
            self.mainElement.find("#wm-search--container .wm-search--input").val("");
        }

        function onTopSuggestionClick(event) {
            self.mainElement.find("#wm-search--container .wm-search--input").val($(this).text());
            event.stopPropagation();
        }

        function onBottomSuggestionClick(event) {
            self.mainElement
                .find("#storemap-searchinput-bottom-container .storemap-inputbar-input")
                .val($(this).text());
            event.stopPropagation();
        }

        function onSearchStoreByIdClick() {
            const resultSotreByIdContainer = self.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
            resultSotreByIdContainer.find(".storemap-suggestion-item").text("");
            resultSotreByIdContainer.hide();
            self.mainElement.find(".wm-autocomplete").hide();

            SERVICE_REGISTRY.storeService.setUniqueStore(self.resultStoreSearchById);
            if (SETTINGS.isAviationPortal) {
                self.mapView.zoomToStore(self.resultStoreSearchById, 0.02);
            }
        }

        function onTopInputSearchChange() {
            const value = $(this).val();
            hideGeolocationNotice();

            if (value.length === 0) {
                self.clearSearchInput();
                self.resultStoreSearchById = null;
            } else {
                self.clearSearchInput();
                SERVICE_REGISTRY.storeService.getStoreByIdOrCode(value, (store) => {
                    if (store !== null) {
                        self.showResultSearchStoreByIdOrCode(store, value);
                    }
                });
            }
        }

        function onInputSearchEnterKeydown(event) {
            if (event.which === 13 || event.keyCode === 13) {
                self._selectFirstResultOfSuggestion();
            }
        }

        function onSearchButtonClick() {
            self._selectFirstResultOfSuggestion();
        }

        function onItinaryCheckBoxClick() {
            $(".storemap-alongtheroad-parameters-container").toggle(this.checked);
            if (this.checked) {
                EventManager.notify(EVENT.SHOW_ITINARY_PANEL, null);
                SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = false;
            } else {
                SERVICE_REGISTRY.itinaryService.setDestination(null);
                SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            }
        }

        function onItinaryCheckOptionsChange() {
            SERVICE_REGISTRY.itinaryService.updateOptions(
                $("#checkbox-avoidHighways").prop("checked"),
                $("#checkbox-avoidTolls").prop("checked"),
                $("#checkbox-avoidFerries").prop("checked"),
            );
        }

        function onReverseItinaryClick() {
            const topInput = $("#wm-search--container .wm-search--inpu");
            const bottomInput = $("#storemap-searchinput-bottom-container .storemap-inputbar-input");

            const topInputText = topInput.val();
            const bottomINputText = bottomInput.val();

            topInput.val(bottomINputText);
            bottomInput.val(topInputText);

            SERVICE_REGISTRY.itinaryService.reverseOriginDestination();
        }

        this.mainElement.find("#inputbar-position-button").click(onGeolocalisationButtonClick);
        this.mainElement.on("keydown", "#inputbar-position-button", function (event) {
            if (["Enter", " ", "Space"].includes(event.key)) {
                event.preventDefault();
                onGeolocalisationButtonClick.call(this, event);
            }
        });
        this.mainElement.on("click", "#wm-search--container", onSearchBarClick);
        this.mainElement.on("click", "#wm-search--container .storemap-inputbar-clear-button", onTopClearButtonClick);
        this.mainElement.on(
            "click",
            "#storemap-searchinput-bottom-container .storemap-inputbar-clear-button",
            onBottomClearButtonClick,
        );
        this.mainElement.on("click", ".wm-autocomplete--item", onTopSuggestionClick);
        this.mainElement.on("click", ".wm-autocomplete--item", onTopSuggestionClick);
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-container-bottom .woosmap-tableview-container .storemap-suggestion-item",
            onBottomSuggestionClick,
        );
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-container-bottom .woosmap-tableview-container .storemap-suggestionByName-item",
            onBottomSuggestionClick,
        );
        this.mainElement.on(
            "click",
            ".storemap-suggestionbar-searchstorebyid-result .storemap-suggestion-item",
            onSearchStoreByIdClick,
        );
        this.mainElement.on("input", "#wm-search--container .wm-search--input", onTopInputSearchChange);
        this.mainElement.on("keydown", ".wm-search--input", onInputSearchEnterKeydown);
        this.mainElement.on("click", ".storemap-inputbar-enter-button", onSearchButtonClick);
        this.mainElement.on("click", ".storemap-filterdetail-list input", onItinaryCheckOptionsChange);
        this.mainElement.on("click", ".storemap-filterdetail-clear-button", onItinaryCheckOptionsChange);
        this.mainElement.on("click", "#along_the_road_option", onItinaryCheckBoxClick);
        this.mainElement.on("click", ".storemap-inputbar-reverse-button", onReverseItinaryClick);
        itinaryStartDatetineInput.on("input change", onItinaryStartDatetimeInputChange);
        itinaryStartDatetimeClearButton.on("click", onItinaryStartDatetimeClearButtonClick);
        // Only the leading magnifier focuses the input. A broader `.wm-icon` selector also
        // matched the geolocation button's icon, focusing the input in the same gesture and
        // stealing the iOS permission prompt.
        this.mainElement.on("click", "#wm-search--container .wm-search--icon", focusInputBox);
    }

    clearSearchInput() {
        SERVICE_REGISTRY.storeService.resetStores();
        SERVICE_REGISTRY.locationService.resetLocation();
        this._hidePredictionsOverlay();
    }

    showResultSearchStoreByIdOrCode(store, term) {
        this.resultStoreSearchById = store;
        const resultStoreByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");

        if (SETTINGS.isAviationPortal) {
            // New design: a single suggestion showing the airport code, no "POI id" header.
            // Echo the code the user actually matched (so typing ICAO shows ICAO, not the IATA);
            // otherwise prefer IATA (code_iata, legacy iata_code fallback), then ICAO.
            const userProperties = store.properties.user_properties;
            const searchTerm = typeof term === "string" ? term.toUpperCase() : "";
            const matchedCode = [userProperties.code_iata, userProperties.code_icao, userProperties.iata_code].find(
                (code) => code && code.toUpperCase() === searchTerm,
            );
            const displayCode =
                matchedCode || userProperties.code_iata || userProperties.iata_code || userProperties.code_icao;
            if (!displayCode) {
                // Nothing to surface for aviation when there is no airport code.
                return;
            }
            resultStoreByIdContainer.addClass("wm-storebyid--aviation");
            resultStoreByIdContainer.find(".storemap-suggestion-header").hide();
            resultStoreByIdContainer.find(".storemap-suggestion-item").text(displayCode);
        } else {
            resultStoreByIdContainer.find(".storemap-suggestion-item").text(store.properties.store_id);
        }

        this.mainElement.find(".wm-autocomplete").show();
        resultStoreByIdContainer.show();
    }

    _selectFirstResultOfSuggestion() {
        const storeSearchByIdContainer = this.mainElement.find(".storemap-suggestionbar-searchstorebyid-result");
        const woosmapSuggestionContainer = this.mainElement.find(".woosmap-tableview-container.card_container");

        const storeSearchByIdItem = storeSearchByIdContainer.find(".storemap-suggestion-item");
        const woosmapSuggestionItems = woosmapSuggestionContainer.find(".storemap-suggestion-item");

        if (storeSearchByIdContainer.is(":visible") && storeSearchByIdItem) {
            $(storeSearchByIdItem[0]).trigger("click");
        } else if (woosmapSuggestionContainer.is(":visible") && woosmapSuggestionItems) {
            $(woosmapSuggestionItems[0]).trigger("click");
        }
    }

    onRefreshList(center) {
        DATA.reverseGeocode(center, (results) => {
            if (results) {
                this.setLocation(center, results[0].formatted_address);
            }
        });
    }

    setLocation(location, searchQuery) {
        setTimeout(() => {
            $("#wm-search--container .wm-search--input").val(searchQuery);
            SERVICE_REGISTRY.locationService.setLocation(location, searchQuery);
        }, 500);
    }
}
